// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/set_selected_for_display.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/set_selected_for_display.proto.
 */
export const file_vision_generations_v1_set_selected_for_display: GenFile = /*@__PURE__*/
  fileDesc("CjR2aXNpb24vZ2VuZXJhdGlvbnMvdjEvc2V0X3NlbGVjdGVkX2Zvcl9kaXNwbGF5LnByb3RvEhxwcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxIpIBChxTZXRTZWxlY3RlZEZvckRpc3BsYXlSZXF1ZXN0ElEKBnBhcmFtcxgBIAEoCzJBLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuU2V0U2VsZWN0ZWRGb3JEaXNwbGF5UmVxdWVzdC5QYXJhbXMaHwoGUGFyYW1zEhUKDWdlbmVyYXRpb25faWQYASABKAkifQodU2V0U2VsZWN0ZWRGb3JEaXNwbGF5UmVzcG9uc2USUgoGcmVzdWx0GAEgASgLMkIucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5TZXRTZWxlY3RlZEZvckRpc3BsYXlSZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.vision.generations.v1.SetSelectedForDisplayRequest
 */
export type SetSelectedForDisplayRequest = Message<"protos.vision.generations.v1.SetSelectedForDisplayRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.SetSelectedForDisplayRequest.Params params = 1;
   */
  params?: SetSelectedForDisplayRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.SetSelectedForDisplayRequest.
 * Use `create(SetSelectedForDisplayRequestSchema)` to create a new message.
 */
export const SetSelectedForDisplayRequestSchema: GenMessage<SetSelectedForDisplayRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_set_selected_for_display, 0);

/**
 * @generated from message protos.vision.generations.v1.SetSelectedForDisplayRequest.Params
 */
export type SetSelectedForDisplayRequest_Params = Message<"protos.vision.generations.v1.SetSelectedForDisplayRequest.Params"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;
};

/**
 * Describes the message protos.vision.generations.v1.SetSelectedForDisplayRequest.Params.
 * Use `create(SetSelectedForDisplayRequest_ParamsSchema)` to create a new message.
 */
export const SetSelectedForDisplayRequest_ParamsSchema: GenMessage<SetSelectedForDisplayRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_set_selected_for_display, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.SetSelectedForDisplayResponse
 */
export type SetSelectedForDisplayResponse = Message<"protos.vision.generations.v1.SetSelectedForDisplayResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.SetSelectedForDisplayResponse.Result result = 1;
   */
  result?: SetSelectedForDisplayResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.SetSelectedForDisplayResponse.
 * Use `create(SetSelectedForDisplayResponseSchema)` to create a new message.
 */
export const SetSelectedForDisplayResponseSchema: GenMessage<SetSelectedForDisplayResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_set_selected_for_display, 1);

/**
 * @generated from message protos.vision.generations.v1.SetSelectedForDisplayResponse.Result
 */
export type SetSelectedForDisplayResponse_Result = Message<"protos.vision.generations.v1.SetSelectedForDisplayResponse.Result"> & {
};

/**
 * Describes the message protos.vision.generations.v1.SetSelectedForDisplayResponse.Result.
 * Use `create(SetSelectedForDisplayResponse_ResultSchema)` to create a new message.
 */
export const SetSelectedForDisplayResponse_ResultSchema: GenMessage<SetSelectedForDisplayResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_set_selected_for_display, 1, 0);

